import { graphql } from "~/gql";

export const DELETE_NOTIFICATION = graphql(/* GraphQL */ `
  mutation DeleteNotification($notificationId: Float!) {
    deleteNotification(notificationId: $notificationId) {
      notificationId
    }
  }
`);
